import { Description } from './description';
import { ISanityHeroTextProps } from './types';
import { getColorForSanityHeroTextColor } from './utils';

export const SanityDescription = Description.withConfig<ISanityHeroTextProps>(
  ({ $sanityTextColor, $defaultTextColor }) => ({
    color: getColorForSanityHeroTextColor($sanityTextColor, $defaultTextColor),
  })
);
